import { withCompanyName } from '@routes/-withCompanyName'
import { createFileRoute } from '@tanstack/react-router'
import { SignUpConfirmPage } from 'features/auth'

export const Route = createFileRoute('/signup/confirm/')({
  component: SignUpConfirmPage,
  head: () => ({
    meta: [
      {
        title: withCompanyName('Sign Up'),
      },
    ],
  }),
})
